import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterCompanyFinCategoriesValue,
  UniversalFilterCompanyFinCategoriesModes,
  UniversalFilterCompanyFinCategoriesFilterState,
  UniversalFilterCompanyFinCategoriesOnChange,
  UniversalFilterCompanyNewFinTagID
} from '../../UniversalFilterCompanyFinCategories.types';

interface UniversalFilterCompanyFinCategoriesFilterStateOptions {
  onChange: UniversalFilterCompanyFinCategoriesOnChange;
}

function useUniversalFilterCompanyFinCategoriesFilterState({
  onChange
}: UniversalFilterCompanyFinCategoriesFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterCompanyFinCategoriesFilterState) => void
  >(
    (filterState) => {
      const categoryIds = filterState?.categoryIds;

      if (
        filterState?.mode === UniversalFilterCompanyFinCategoriesModes.IS_ANY_OF
      ) {
        onChange(isEmpty(categoryIds) ? undefined : { in: categoryIds });
        return;
      }

      if (
        filterState?.mode ===
        UniversalFilterCompanyFinCategoriesModes.IS_NONE_OF
      ) {
        onChange(isEmpty(categoryIds) ? undefined : { notIn: categoryIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterCompanyFinCategoriesValue
    ) => UniversalFilterCompanyFinCategoriesFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue.in)) {
      return {
        mode: UniversalFilterCompanyFinCategoriesModes.IS_ANY_OF,
        categoryIds: filterValue.in as UniversalFilterCompanyNewFinTagID[]
      };
    }

    if (!isEmpty(filterValue.notIn)) {
      return {
        mode: UniversalFilterCompanyFinCategoriesModes.IS_NONE_OF,
        categoryIds: filterValue.notIn as UniversalFilterCompanyNewFinTagID[]
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterCompanyFinCategoriesFilterState;
